var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCellularConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.647 165.42h.647c.357 0 .647.296.647.663v1.325c0 .367-.29.663-.647.663h-.647c-.357 0-.647-.296-.647-.663v-1.325c0-.367.29-.663.647-.663zm3.02-1.326h.647c.357 0 .647.297.647.663v2.651c0 .367-.29.663-.647.663h-.647c-.358 0-.647-.296-.647-.663v-2.651c0-.366.29-.663.647-.663zm3.02-1.547h.646c.358 0 .647.297.647.663v4.198c0 .367-.29.663-.647.663h-.647c-.357 0-.647-.296-.647-.663v-4.198c0-.366.29-.663.647-.663zm3.019-1.547h.647c.357 0 .647.297.647.663v5.745c0 .367-.29.663-.647.663h-.647c-.357 0-.647-.296-.647-.663v-5.745c0-.366.29-.663.647-.663z",
    transform: "translate(-1161 -161)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellularConnection);
export default __webpack_public_path__ + "static/media/cellular-connection.768b05f9.svg";
export { ForwardRef as ReactComponent };